import React from 'react';
import { reduce, result } from 'underscore';
import { ViewmodelSchema } from '@bingads-webui/viewmodel-schema';

import { RemainingCharsHint } from './remaining-chars-hint';

export const getRemainingCharsHintTextWithSchema = (str, i18n, schema, field) => {
  const vmSchema = new ViewmodelSchema(schema, i18n, [field]);
  const vmField = reduce(field.split('/'), (obj, seg) => result(obj, seg), vmSchema);
  const vmFieldSchema = result(vmField, 'prop', {});
  const fieldSchema = {
    distinguishWideChar: true,
    ...vmFieldSchema,
  };
  return (<RemainingCharsHint str={str} newI18n={i18n} schema={fieldSchema} />);
};

export const getRemainingCharsHintText = (str, i18n, maxLength) => {
  const fieldSchema = {
    maxLength,
    distinguishWideChar: true,
  };
  return (<RemainingCharsHint str={str} newI18n={i18n} schema={fieldSchema} />);
};
